(function($) {
  'use strict';
  window.addEventListener('load', function(e) {
    $('.tmp_accordions-wrapper').each(function(e) {
      var $accContainer = $(this);
      if ($accContainer.attr('data-acc-loaded') === 'not-loaded') {
        $accContainer.attr('data-acc-loaded', 'loaded');
        var $accTitles = $accContainer.find('.tmp_accordions-title');
        $accTitles.each(function(e) {
          var $title = $(this);
          $title.click(function(e) {
            if ($accContainer.data('accordion-type') === 'single') {
              $accContainer
                .find('.tmp_accordions-content')
                .not($title.next())
                .slideUp('fast');
              $title.next().slideToggle('fast');
              $accContainer
                .find('.tmp_accordion')
                .not($title.parent())
                .removeClass('active');
            } else {
              $title.next().slideToggle('fast');
            }
            $title.parent().toggleClass('active');
            return false;
          });
        });
      }
    });
  });
}(jQuery));
